const setProjectid = payload => {
  return {
    type: "projectid",
    payload
  };
};

export default setProjectid;
